import { useNavigate } from "react-router"
import { Button } from "../../../../components"

/**
 * This component is used to redirect the user to the tier list page.
 *
 * @returns A button that redirects the user to the tier list page.
 */
export const RedirectToTierListButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      type="primary"
      className="w-[222px] text-sm !p-1.5 mt-1 h-fit self-center"
      onClick={() => navigate("/data-inputs/tiers")}
    >
      Tier List
    </Button>
  )
}